export const eiqSecureResidentLicenseValidation = {
  gate: [{ required: true, message: 'Gate is required!' }],
  carLicensePlate: [{ required: true, message: 'License is required!' }],
  carState: [{ required: true, message: 'License state is required!' }],
  driverCompanyName: [{ required: true, message: 'Driver company name is required!' }],
  driverLastName: [{ required: true, message: 'Driver first name is required!' }],
  driverFirstName: [{ required: true, message: 'Driver last name is required!' }],
};
